export default __webpack_public_path__ + "9741bef52f712f3b3027599b6e326801.webp";